import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/primary-arrow-left.png'
import _imports_1 from '@/assets/icon/icon-arrow-right-green.png'


const _withScopeId = n => (_pushScopeId("data-v-bbd16c5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

import { nextTick, onMounted, ref, computed } from 'vue';
  import { StoryCategory } from '@/types/story';
  import { useI18n } from 'vue-i18n';

  interface IProps {
    categoryId: number;
    list: StoryCategory[];
  }

  interface IEmits {
    (event: 'change', categoryId: number): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    categoryId: null,
    list: null
  },
  emits: ["change"],
  setup(__props: any, { expose, emit: emits }: { emit: ({
    (event: 'change', categoryId: number): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    categoryId: number;
    list: StoryCategory[];
  }

  const colorBlack = ref('#000');
  const colorGreen = ref('#a8dd97');
  const colorYellow = ref('#eecc3f');
  
  
  const { t, locale } = useI18n();
  const filterRef = ref<HTMLElement>();
  const scrollRef = ref<HTMLElement>();
  const scrollLeft = ref(0);
  const showArrow = ref(false);
  const isKorea = process.env.VUE_APP_COUNTRY === 'ko';
  const categories = computed(() => {
    if (!props.list.length) {
      return [];
    }
    return [
      {
        id: 0,
        title: t('All'),
        font_color: (props.categoryId === 0) && isKorea && !isLargeScreen.value ? '#fff' : colorBlack.value, // 韩国环境下小屏hashTag被选中、字体为白色
        background_color: isKorea ? '#005034' : colorGreen.value, // 韩国环境下tag背景色为绿色
      },
      ...props.list,
    ];
  });

  expose({ initScrollArrow });

  onMounted(async () => {
    await nextTick();
    initScrollArrow();
    const selectedEle = scrollRef.value?.querySelector('.selected');
    if (selectedEle) {
      const { left } = selectedEle.getBoundingClientRect();
      scrollRef.value?.scrollTo({ left: left - 100 });
    }
  });

  // 移动距离正负根据实际调整
  async function handleScroll(move: number) {
    const value = Number(scrollRef.value?.scrollLeft);
    scrollRef.value?.scrollTo({ left: value + move });

    await nextTick();
    scrollLeft.value = Number(scrollRef.value?.scrollLeft);
  }

  function initScrollArrow() {
    if (scrollRef.value && filterRef.value) {
      showArrow.value = scrollRef.value.scrollWidth > filterRef.value.scrollWidth;
    }
  }

  const isLargeScreen = ref(window.innerWidth >= 992); // 992px 是 Bootstrap 的 lg 断点
  window.addEventListener('resize', () => {
    isLargeScreen.value = window.innerWidth >= 992;
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "filterRef",
    ref: filterRef,
    class: _normalizeClass(["filter-wrapper", `lang-${_unref(locale)}`])
  }, [
    (scrollLeft.value)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "arrow hidden-xs-only",
          src: _imports_0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleScroll(-100)))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      ref_key: "scrollRef",
      ref: scrollRef,
      class: "list-box"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["item", { selected: __props.categoryId === item.id }]),
          style: _normalizeStyle(__props.categoryId === item.id && !isLargeScreen.value ? { color: item.font_color || colorBlack.value, borderColor: item.background_color || colorGreen.value, backgroundColor: item.background_color || colorGreen.value } : {}),
          onClick: ($event: any) => (emits('change', item.id))
        }, [
          _createElementVNode("span", {
            class: "circle",
            style: _normalizeStyle(__props.categoryId === item.id && isLargeScreen.value ? { borderColor: item.background_color || colorYellow.value } : {})
          }, null, 4),
          _createElementVNode("span", {
            class: "name",
            style: _normalizeStyle(__props.categoryId === item.id && isLargeScreen.value ? { color: item.background_color || colorYellow.value } : {})
          }, _toDisplayString(item.title), 5)
        ], 14, _hoisted_1))
      }), 128))
    ], 512),
    (showArrow.value)
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          class: "arrow hidden-xs-only",
          src: _imports_1,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleScroll(100)))
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})